import React, { memo } from "react";

interface IProps {
  data: {
    brandName: string;
    kindName: string;
    price: string;
    thumb: string;
    link: string;
  }[];
}

const RelatedModels: React.FC<IProps> = ({ data }) => {
  return (
    <div className="w-full py-20 px-0">
      <p className="text-28 font-[700] text-left text-[#333333] leading-[34px] mb-18">相關車款</p>
      <div className="w-full gap-20 grid grid-cols-2">
        {data.map((item) => (
          <a href={item.link} key={item.link} className="w-[160px] h-[180px] flex flex-col justify-between items-center">
            <img src={item.thumb} alt={item.brandName} width="160" height="108" style={{ aspectRatio: "160/108" }} />
            <p className="text-16 text-center text-[#333] leading-[18px] line-clamp-1">{`${item.brandName} ${item.kindName}`}</p>
            <p className="text-16 text-center text-[#666] leading-[16px] line-clamp-1">{item.price}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default memo(RelatedModels);
